import * as React from "react";
import NavbarLayout from "components/Layout/NavbarLayout";
import { useContentfulForTypeAndKey } from "source/contentful/provider";
import {
  DisclosuresDocument,
  ContentfulContentType,
  ContentfulKey,
} from "@tiicker/util/lib/contentful/types";
import LoadingBlock from "components/Loading/LoadingBlock";
import { RichText } from "components/Contentful/RichText";
import Head from "next/head";
import getBaseUrl from "@tiicker/util/lib/get-base-url";
import styles from "./disclosures.module.scss";

const Disclosures = () => {
  const disclosuresContentQuery =
    useContentfulForTypeAndKey<DisclosuresDocument>(
      ContentfulContentType.Disclosures,
      ContentfulKey.Disclosures
    );
  const currentURL = `${getBaseUrl()}disclosures`;
  const pageDescription =
    "TiiCKER.COM Disclosures: Information contained herein is the opinion of Tiicker.com and is intended to be used strictly for informational purposes.";

  return (
    <>
      <Head>
        <title>Disclosures | TiiCKER</title>
        <meta
          name="description"
          key="meta-description"
          content={pageDescription}
        />
        <meta
          property="og:description"
          key="description"
          content={pageDescription}
        />
        <meta property="og:url" key="url" content={currentURL} />
      </Head>
      <NavbarLayout>
        <div className="container">
          <h1 className={styles.title}>Disclosures</h1>
          {disclosuresContentQuery.state === "DONE" ? (
            <RichText
              document={disclosuresContentQuery.result.items[0].fields.content}
              className={styles.disclosure}
            />
          ) : (
            <LoadingBlock />
          )}
        </div>
      </NavbarLayout>
    </>
  );
};

export default Disclosures;
